<template>
  <div
    v-if="user.group === 777"
    :class="`${
      user.aura_color ? `aura-color-${user.aura_color}` : ''
    } ${
      user.aura_item ? `aura-item ${user.aura_item}` : ''
    }`"
    class="nucles"
  >
    <div><div></div></div>
    <div><div></div></div>
    <div><div></div></div>
    <div><div></div></div>
  </div>
</template>

<script>
  export default {
    props: {
      user: { type: Object, require: true, default: () => ({ group: 1 }) }
    }
  }
</script>

<style src="~/assets/nucles.styl" lang="stylus" />
